/* eslint-disable @typescript-eslint/no-explicit-any */
// Imports for external libraries go here.
import React, { FC, useEffect, useId, useMemo, useState } from 'react';
import clsx from 'clsx';
import { constants } from '../../modules';
import { InputTextField, Types } from '@marriott/mi-ui-library';

import { Dropdown } from '../Dropdown';
import { PhoneNumberFieldProps } from './PhoneNumberField.types';
import { StyledPhoneNumberField } from './PhoneNumberField.styles';

// Use named rather than default exports.
export const PhoneNumberField: FC<PhoneNumberFieldProps> = props => {
  const {
    label,
    mobileInputVal,
    isInputError,
    inputErrorMsg,
    placeHolderText,
    defaultCCOption,
    dropdownCCOptions,
    dropdownId,
    disabled = false,
    fetchMobileNumber,
    isNonChinaMobileEnabled = false, //this flag is used to identify if country code dropdown in enabled by default its dissabled
    isRegisteredNumber = false,
    isMobileEditable = false,
    showIdandValueinOptions = false,
    numberLength = 16,
    badgeProp,
    inputTextLabel,
    inlineLabel,
    iconClass,
    iconAriaLabel,
    resetForm,
  } = props;

  const [mobileNumber, setMobileNumber] = useState('');
  const [isPrePopulatedNumber, setPrePopulatedNumber] = useState(false);

  const initialCountry = useMemo(() => {
    const found = dropdownCCOptions?.find((country: any) => country.id === defaultCCOption);
    return {
      id: found?.id || defaultCCOption || '',
      dialCode: found?.value || constants.USA_COUNTRY_DIAL_CODE,
    };
  }, [defaultCCOption, dropdownCCOptions]);

  const [selectedCountry, setSelectedCountry] = useState(initialCountry);

  useEffect(() => {
    setSelectedCountry(initialCountry);
  }, [initialCountry]);

  useEffect(() => {
    setMobileNumber(mobileInputVal);
    !isMobileEditable && setPrePopulatedNumber(mobileInputVal?.length > 0);
  }, [mobileInputVal]);
  const inputId = useId();

  const handleCountryCodeChange = (option: any) => {
    setSelectedCountry({
      id: option?.id,
      dialCode: option?.countryDialCode,
    });
    setCompleteMobileNumber(option?.countryDialCode, mobileNumber, option?.id);
  };

  const handleKeyPress = (ev: any) => {
    /**
     * handle key press event on input field that will submit the
     * form
     */
    if (ev.key === 'Enter' || ev.keyCode === 13) {
      // handleCountryCodeChange()
    }
  };
  const setCompleteMobileNumber = (cc: string, mobNum: string, id?: string) => {
    fetchMobileNumber({
      countryCode: cc,
      mobileNumber: mobNum,
      id: id,
    });
  };

  return (
    <StyledPhoneNumberField data-component-name="m-account-PhoneNumberField" data-testid="account-PhoneNumberField">
      <div className="d-flex row">
        <div className={clsx('dropdown-field col-12 col-sm-6 px-2', inlineLabel && 'phonenumber-standard')}>
          {!inlineLabel && (
            <label
              className="country-label m-ellipsis-1line numberfieldwidth"
              id="dropdown-label-country-code"
              htmlFor="dropdown-label-fp-country"
              data-testid="dropdown-label-fp-country"
            >
              {label}
            </label>
          )}
          <Dropdown
            defaultOption={selectedCountry.dialCode || constants.USA_COUNTRY_DIAL_CODE}
            dropdownOptions={dropdownCCOptions || []}
            onChange={handleCountryCodeChange}
            customClassName={clsx(
              'country-code-dropdown',
              { 'is-disabled': disabled },
              !inlineLabel && 'country-code-dropdown_standard'
            )}
            dropdownId="country-code"
            id={dropdownId || 'dropdown-label-fp-country'}
            labelSize={Types.size.medium}
            showIdandValueinOptions={showIdandValueinOptions}
            hasLabel={inlineLabel ? label : ''}
          ></Dropdown>
          {disabled || !isNonChinaMobileEnabled || isPrePopulatedNumber ? <div className="blurred"></div> : ''}
        </div>
        <div className="inputtext-field col-12 col-sm-6 mt-sm-0 mt-5 px-2">
          <InputTextField
            label={inputTextLabel || ''}
            inputValue={mobileNumber}
            showErrorMessage={isInputError}
            placeHolderText={placeHolderText}
            messageToShow={inputErrorMsg}
            setErrorHtml={true}
            messageClass="error-label"
            inputMaxLength={numberLength}
            infoLabel={'Phone-number-field'}
            getInputProps={() => ({
              /** setReadOnly props for remeber case */
              autoComplete: 'off',
              onKeyUp: handleKeyPress,
              id: `${inputId}-Dialcode`,
              disabled: disabled || isRegisteredNumber || isPrePopulatedNumber,
            })}
            getLabelProps={() => ({
              htmlFor: `dropdown-label-fp-country`,
            })}
            className={clsx(
              inlineLabel ? 'm-input-text-field' : 'm-input-field',
              disabled || isRegisteredNumber || isPrePopulatedNumber ? 'is-disabled' : ''
            )}
            getInputValue={(val: string) => {
              setMobileNumber(val);
              setCompleteMobileNumber(selectedCountry.dialCode, val, selectedCountry.id);
              val && resetForm?.('mobilePhone');
            }}
            showBadge={!inlineLabel && !!badgeProp}
            badgeValue={inlineLabel ? '' : badgeProp}
            testId="phone-number-field"
            showIcon={!!inlineLabel}
            iconClass={inlineLabel ? iconClass || '' : ''}
            iconAriaLabel={iconAriaLabel}
          />
          {inlineLabel && !!badgeProp && <div className="t-font-alt-xs mt-1">{badgeProp}</div>}
        </div>
        {disabled || isPrePopulatedNumber ? <div className="blurred"></div> : ''}
      </div>
    </StyledPhoneNumberField>
  );
};
